export default __webpack_public_path__ + "static/media/balloons_responsive.cb365082.png";